var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331.2 331.2",
    style: {
      enableBackground: "new 0 0 331.2 331.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003B5C;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 331.2,
    height: 331.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.1,245l-23.2-60h14.6l16.6,46.2l16.6-46.2h14.6l-23.1,60H111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.9,245v-60h12.8v60H156.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.8,221v-36.1h13v35.6c0,8.4,4.9,14.1,14.1,14.1c9.3,0,14-5.8,14-14.1v-35.6h13v36 c0,14.9-8.8,25.1-27.1,25.1C191.6,246.1,182.8,235.8,182.8,221z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,130.4c0,0,19.2-22.1,42.2-23.1c22.9-0.9,42.6,8.6,56,8.1c13.5-0.5,22.8-4.4,30.8-10.3 c0-0.2,2.3,4.4-2.8,6.2c-5.2,1.7-15.5,5.9-6.9,12.5c2.8,1.8,5.8,3.5,0.3,3.5c-5.5-0.1-37-0.6-44,21.7c-0.2,0.1-3.8-3-4.6-3.2 c-0.9-0.2-6.4,5.9-6.9,9c0,0-2.2-4.4-2.7-6.6c-0.5-2.3-0.8-5.3-0.8-5.3c-0.7-0.6-6.3,2.2-7.1,3.3c0.1-2.2-0.6-11.1,12.9-17.1 c-10.5,0.4-22.6,1.1-37.9,14.9c0,0-0.9-9.6,2.7-17.4C131.1,126.2,119.1,123.4,100.8,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.2,103.3L154.8,85l22.3,14l2.5-0.9L164,87.5l12.8-7.8l32,32c0,0-7.9,2.6-20.2-0.4 c-12.3-2.9-24-8.2-37-9.3C139.7,101.1,130.2,103.3,130.2,103.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViu);
export default __webpack_public_path__ + "static/media/VIU.a42bfebb9673ad370818ce492281e2c0.svg";
export { ForwardRef as ReactComponent };